import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../apiEndPoints";
import { logout } from "../features/authSlice";
const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { getState, endpoint }) => {
    const user_token = getState().auth.id;
    const access_token = getState().auth.access_token;
    if (endpoint === "logout") {
      headers.set("Authorization", `Bearer ${access_token}`);
      return headers;
    } else {
      if (user_token) {
        headers.set("Authorization", `Bearer ${access_token}`);
      }
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    api.dispatch(logout());
  }

  return result;
};

export const api = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: [],
  endpoints: () => ({}),
});
